import { FiShoppingCart } from 'react-icons/fi';
import hqLogoBlack from '../assets/images/hqrent-black.png'
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Badge } from 'antd';

const Header = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation(); 
  const partnerInfo = useSelector((state: any) => state.setting.partnerInfo);
  const cartItem = useSelector((state:any) => state.setting.cartItems);

  const isConfirmationPage =
    location.pathname === '/confirmation' ||
    location.pathname.startsWith('/confirmation/');
  
  const handleLogoClick = () => {
    // Check if the user is on the homepage
    if (location.pathname === '/') {
      // Open the partner's website if it exists
      if (partnerInfo?.website) {
        let url = partnerInfo.website;
        // Ensure the URL starts with a protocol
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = `https://${url}`;
        }
        window.open(url, '_blank');
      }
    } else {
      // Navigate to the homepage if not already there
      navigate('/');
    }
  };

  return (
    <div>
      <div className={" p-25 mx-auto bg-white border-b-1"} data-testid="header-container">
        <div className='flex justify-between items-center text-24'>
          <div
            className='cursor-pointer'
            onClick={handleLogoClick}
            data-testid="header-logo-button"
          >
            {partnerInfo && Object.keys(partnerInfo).length > 0 &&
              <img src={partnerInfo?.resourceURL || hqLogoBlack} className='App-logo' alt='' />
            }
          </div>
          {!isConfirmationPage && (
            <Badge count={cartItem.length} style={{ background: '#1677FF'}} data-testid="header-cart-badge">
              <FiShoppingCart
                className='cursor-pointer'
                onClick={() => navigate('/cart')}
                style={{fontSize: '24px'}}
                data-testid="header-cart-button"
              />
            </Badge>
          )}
        </div>
      </div>
    </div>

  )
}

export default Header;
